import { render } from "./SaleHome.vue?vue&type=template&id=4f273b5e&scoped=true"
import script from "./SaleHome.vue?vue&type=script&lang=js"
export * from "./SaleHome.vue?vue&type=script&lang=js"

import "./SaleHome.vue?vue&type=style&index=0&id=4f273b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f273b5e"]])

export default __exports__